import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import '@/assets/css/reset.scss'
import '@/assets/css/mixin.scss'
import Api from '@/assets/js/ajax'

Vue.config.productionTip = false

Vue.use(ElementUI)
Vue.prototype.$ELEMENT = {size: 'medium'}
Vue.prototype.$api = Api

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js